<template lang="pug">
  .invoice-page
    .section(v-if="info")
      .container.has-text-centered.visible-overflow
        h1 {{ gettext('Invoiсe') }}
        .columns
          .column.invoice-wrap
            .card
              header.card-header
                p.card-header-title
                  | {{gettext('Invoice')}} # {{info.invoice.id}} &nbsp;
                  span.has-text-danger(v-if="status.code === CONSTANTS.INVOICE_STATUS_CANCELED") ({{gettext('Invoice canceled')}})
                  span.has-text-success(v-if="status.code === CONSTANTS.INVOICE_STATUS_PAYED") ({{gettext('Invoice payed')}})
                .card-header-icon
                  button.is-success.main-btn(@click="details = !details") {{ !details ? gettext('Show details') : gettext('Close details') }}
              .card-content
                .content
                  table.table
                    thead
                      tr
                        th {{gettext('Items')}}
                        th
                        th {{gettext('Price')}}
                    tbody
                      tr(v-for="item in info.items")
                        td
                          p.is-marginless {{getAlias(item.type)}}
                          p.bold.t-12(v-if="item.type === CONSTANTS.CV_INVOICE_ITEM_NAME")
                            | {{interpolate(ngettext('%s day', '%s days', item.expiration_time), [item.expiration_time]) }}/{{interpolate(ngettext('%s contact', '%s contacts', item.hits_number), [item.hits_number])}}
                        td
                        td {{item.amount}} &euro;
                      tr
                        td
                        td {{gettext('Vat')}} ({{info.invoice.vat_percent}} %)
                        td {{info.invoice.amount_vat}} &euro;
                      tr
                        td
                        td {{gettext('Total')}}
                        td {{info.invoice.amount_total}} &euro;
                      tr
                        td
                        td {{gettext('Payed')}}
                        td {{info.invoice.payment_info.payed.total}} &euro;
                      tr
                        td
                        th {{gettext('Residue')}}
                        th {{info.invoice.payment_info.residue.total}} &euro;
                  .payment-method-block.columns
                    .column {{gettext('Payment method')}}
                    .column
                      ajax-dropdown.is-borderless(
                        v-if="getFinanceAccount"
                        v-model="paymentMethod"
                        :disabled="status.code !== CONSTANTS.INVOICE_STATUS_PENDING"
                        :labelText="gettext('Choose payment method')"
                        :action="{method: 'getPayMethods', params:{lang: getLanguage, account: getFinanceAccount, invoice: parseInt($route.query.id)}}"
                        :itemName="'name'"
                      )
                  .pay-card(v-if="paymentMethod")
                    .credit-card(v-if="paymentMethod.paymethod === CONSTANTS.STRIPE_PAYMETHOD")
                      card-element(
                        :label="gettext('Credit or debit card')"
                        :apiKey="paymentMethod.data.PUBLIC_KEY"
                        :inputName="gettext('Amount')"
                        :disabled="!info.invoice.is_allowed_to_pay_partially"
                        :amountMin="paymentMethod.data.MIN_AMOUNT"
                        :amountMax="paymentMethod.data.MAX_AMOUNT"
                        :autoSubmit="true"
                        :data="validPayment"
                        :error="validationError"
                        @created="validatePay()"
                        @updated="stripeProcess"
                        @result="stripeProcess"
                        @isValid="cardValid = $event"
                      )
                    .account-card(v-else)
                      acc-element(
                        :data="validPayment"
                        :disabled="!info.invoice.is_allowed_to_pay_partially"
                        :manual="paymentMethod.paymethod !== CONSTANTS.ACC_FUNDS_PAYMETHOD"
                        :error="validationError"
                        :amountMin="paymentMethod.data.MIN_AMOUNT"
                        :amountMax="paymentMethod.data.MAX_AMOUNT"
                        @created="validatePay()"
                        @isValid="cardValid = $event"
                        @updated="throttledValidate($event)")

              footer.card-footer
                button.main-btn.card-footer-item.bg-red.col-white(v-if="paymentMethod" @click="next" :disabled="formInvalid || !cardValid") {{gettext('Next')}}
          .column.details-wrap
            transition(name="fade")
              .card.details(v-if="details")
                header.card-header
                  p.card-header-title
                    | {{gettext('Details')}}
                .card-content
                  .content
                    table.table
                      tbody
                        tr
                          th {{gettext('Items')}}
                        tr
                          v-accordion(v-for="(item, index) in info.items" :key="index")
                            template(slot="header")
                              .item-header
                                div {{getAlias(item.type)}}
                                div {{item.amount}} &euro;
                            .item-body(v-if="item.type === CONSTANTS.CV_INVOICE_ITEM_NAME")
                              table.table.table-descr
                                thead
                                  tr
                                    th {{gettext('Description')}}
                                    th {{gettext('Expiration time')}}
                                    th {{gettext('Hits number')}}
                                tbody
                                  tr
                                    td {{item.description}}
                                    td {{interpolate('%s days', [item.expiration_time])}}
                                    td {{item.hits_number}}
                            .item-body(v-if="item.type === CONSTANTS.PERSONAL_MATCH_TYPE_NAME || item.type === CONSTANTS.PAPER_WORK_TYPE_NAME")
                              table.table
                                tbody
                                  tr
                                    td {{gettext('Employer from')}}
                                    td {{countries.find(x => x.id === item.employer_country_id).name}}
                                  tr
                                    td {{gettext('Employee from')}}
                                    td {{countries.find(x => x.id === item.jobseeker_country_id).name}}
                    div
                      strong {{gettext('Invoice details')}}
                      table.table
                        tbody
                          tr
                            td {{gettext('Invoice amount')}}
                            td {{info.invoice.amount}} &euro;
                          tr
                            td {{gettext('Vat percent')}}
                            td {{info.invoice.vat_percent}} %
                          tr
                            td {{gettext('Vat amount')}}
                            td {{info.invoice.amount_vat}} &euro;
                          tr
                            th {{gettext('Total amount')}}
                            th {{info.invoice.amount_total}} &euro;
                    div
                      strong {{gettext('Payment details')}}
                      table.table
                        thead
                          tr
                            th #
                            th {{gettext('Amount')}}
                            th {{gettext('Vat')}}
                            th {{gettext('Total')}}
                        tbody
                          tr
                            th {{gettext('Payed')}}
                            td {{info.invoice.payment_info.payed.amount}}
                            td {{info.invoice.payment_info.payed.vat}}
                            th {{info.invoice.payment_info.payed.total}}
                          tr
                            th {{gettext('Residue')}}
                            td {{info.invoice.payment_info.residue.amount}}
                            td {{info.invoice.payment_info.residue.vat}}
                            th {{info.invoice.payment_info.residue.total}}
    .section.invoice-not-found(v-else)
      .container.has-text-centered(v-if="!process")
        h1 {{ gettext('Invoiсe error') }}
        .columns
          .column.invoice-wrap
            .card
              .card-content
                p
                  strong {{gettext('Sorry, but there was an error. Perhaps this invoice does not exist anymore.')}}
</template>
<script>

import { gettext, interpolate, ngettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import VAccordion from './components/accordion'
import CardElement from './components/card-element'
import AccElement from './components/account-funds-element'
import AjaxDropdown from './components/dropdown'
import { parseURL, updateQuery } from '@/services/Utils'
import mixin from '@/mixins'
const CONSTANTS = require('@/constants.json')
const _ = require('lodash')
const toastr = require('toastr')

export default {
  name: 'Invoice',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  components: {
    VAccordion,
    AjaxDropdown,
    CardElement,
    AccElement
  },
  data () {
    return {
      info: null,
      details: false,
      CONSTANTS: CONSTANTS,
      aliases: {},
      paymentMethod: '',
      paymentData: '',
      validPayment: {},
      status: false,
      process: true,
      validationError: '',
      stripeData: {},
      cardValid: true,
      amount: null,
      extra: null,
      countries: []
    }
  },
  methods: {
    gettext: gettext,
    interpolate: interpolate,
    ngettext: ngettext,
    ...mapActions([
      'getBillingInvoiceDetail',
      'validatePayment',
      'registerPayment',
      'receiveCountries'
    ]),
    getAlias (alias) {
      let result = alias
      _.each(this.aliases, (item, key) => {
        if (item === alias) result = key
        else if (key === alias) result = item
      })
      return result
    },
    setAliases () {
      this.$set(this.aliases, CONSTANTS.CV_INVOICE_ITEM_NAME, gettext('CV contacts item'))
      this.$set(this.aliases, CONSTANTS.ACCOUNT_TOPUP_INVOICE_NAME, gettext('Account top up item'))
    },
    stripeProcess (data) {
      this.amount = data.amount
      this.extra = data.token ? {'stripe_token': data.token} : null
      this.validatePay(data.amount, this.extra)
    },
    validatePay (amount, extra = null) {
      this.process = true
      this.amount = amount
      return new Promise((resolve, reject) => {
        this.validatePayment({
          lang: this.getLanguage,
          account: this.getFinanceAccount,
          invoice: parseInt(this.$route.query.id),
          paymethod: this.paymentMethod.paymethod,
          amount: amount ? amount.toString() : null,
          extra: extra
        }).then(res => {
          this.validPayment = res
          this.paymentData = res.signed_payment_data
          this.process = false
          this.validationError = ''
          resolve(res)
        }).catch(err => {
          this.validationError = (err.data.error || {}).message
          reject(err)
        })
      })
    },
    registerPay () {
      this.registerPayment(this.paymentData).then(res => {
        if (res.success) {
          if (res.data.action === 'AJAX') {
            this.ajaxRequest(res.data.method, res.data.url, res.data.post_data)
          } else {
            this.formRequest(res.data.method, res.data.url, res.data.post_data)
          }
        } else {
          toastr.error(gettext('Payment error!'), gettext('Error!'))
        }
      })
    },
    formRequest (method, url, params, redirect = `${window.location.origin}/${this.getLanguage}/profile/cabinet`) {
      let form = document.createElement('form')
      form.setAttribute('method', method)
      if (method === 'GET') {
        params = Object.assign(parseURL(url).searchObject, {back: window.location.href, next: redirect})
      }
      for (let key in params) {
        if (params.hasOwnProperty(key)) {
          if (params[key]) {
            let hiddenField = document.createElement('input')
            hiddenField.setAttribute('type', 'hidden')
            hiddenField.setAttribute('name', key)
            hiddenField.setAttribute('value', params[key])
            form.appendChild(hiddenField)
          }
        }
      }
      url = updateQuery(url, {back: window.location.href, next: redirect})
      form.setAttribute('action', url)
      document.body.appendChild(form)
      form.submit()
    },
    ajaxRequest (method, url, data, redirect = {name: 'Cabinet', params: {lang: this.getLanguage}}) {
      this.process = true
      let formData = new FormData()
      for (let key in data) {
        formData.append(key, data[key])
      }
      let params = {
        method: method,
        url: url,
        data: ['POST', 'post'].indexOf(method) !== -1 ? formData : undefined,
        headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-type': 'multipart/form-data'}
      }
      this.$http(params).then((res) => {
        if (res.data.success) {
          this.$router.push(redirect)
        } else {
          toastr.error(gettext('Payment error!'), gettext('Error!'))
          this.process = false
        }
      }).catch(() => {
        toastr.error(gettext('Payment error!'), gettext('Error!'))
        this.process = false
      })
    },
    async next () {
      if (this.paymentData) {
        this.registerPay()
      } else {
        await this.validatePay(this.amount, this.extra)
        this.registerPay()
      }
    },
    throttledValidate: _.debounce(function (amount, extra = null) {
      this.validatePay(amount, extra)
    }, 400)
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getFinanceAccount'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Invoice'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    formInvalid () {
      return this.process
    }
  },
  watch: {
    paymentData: function (val) {
      if (val) {
        setTimeout(() => {
          this.paymentData = ''
        }, 30000)
      }
    }
  },
  created () {
    this.setAliases()
    this.receiveCountries({lang: this.getLanguage}).then(res => {
      this.countries = res
    })
    if (this.$route.query.id) {
      this.process = true
      this.getBillingInvoiceDetail({lang: this.getLanguage, invoice: parseInt(this.$route.query.id)}).then(res => {
        this.info = res
        this.status = res.invoice.status
        this.process = false
      }).catch(() => {
        this.process = false
      })
    } else {
      this.process = false
    }
  }
}
</script>

<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/billing/invoice/index.vue